import { useRef, useEffect } from "react";
import { onEvent, offEvent } from "./vanilla.mjs";
function useEvent(eventName, handler, deps = [], options) {
  const handlerRef = useRef(handler);
  useEffect(() => void (handlerRef.current = handler), [handler]);
  useEffect(() => {
    const handler2 = (event) => {
      var _a;
      return (_a = handlerRef.current) == null ? void 0 : _a.call(handlerRef, event);
    };
    const context = onEvent(eventName, handler2, options);
    return () => offEvent(eventName, handler2, { ...options, context });
  }, [eventName, options == null ? void 0 : options.once, ...deps]);
}
export {
  useEvent
};
//# sourceMappingURL=react.mjs.map
